import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { Checkbox } from '@progress/kendo-react-inputs';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs';
import { ContentTypeFieldResponse, CPS_CONTENT_TYPE_FIELD_TYPE } from '@cs-cms/types';

interface CustomFieldCellProps extends GridCellProps {
  ctField: ContentTypeFieldResponse;
  getFieldChoices: (field: any) => any[];
}

export const CustomFieldCell: React.FC<CustomFieldCellProps> = props => {
  const { ctField, getFieldChoices, dataItem, field, onChange, dataIndex } = props;

  // Get value from dataItem
  const fieldName = field?.replace('perFileMetadata.', '') || '';
  const value = dataItem?.perFileMetadata?.[fieldName];

  // Handler that integrates with Grid's editing system
  const handleChange = (newValue: any) => {
    if (onChange) {
      onChange({
        dataItem,
        dataIndex,
        field,
        syntheticEvent: {} as any,
        value: newValue
      });
    }
  };

  switch (ctField.type) {
    case CPS_CONTENT_TYPE_FIELD_TYPE.DATE:
      return <DatePicker value={value} onChange={e => handleChange(e.value)} required={ctField.required} />;

    case CPS_CONTENT_TYPE_FIELD_TYPE.DATETIME:
      return <DateTimePicker value={value} onChange={e => handleChange(e.value)} required={ctField.required} />;

    case CPS_CONTENT_TYPE_FIELD_TYPE.BOOL:
      return <Checkbox value={value || false} onChange={e => handleChange(e.value)} required={ctField.required} />;

    case CPS_CONTENT_TYPE_FIELD_TYPE.CHOICE: {
      const choices = getFieldChoices(ctField);
      return (
        <DropDownList
          data={choices}
          value={value || null}
          onChange={e => handleChange(e.value)}
          required={ctField.required}
        />
      );
    }
    case CPS_CONTENT_TYPE_FIELD_TYPE.MULTI_CHOICE: {
      const multiChoices = getFieldChoices(ctField);
      return (
        <MultiSelect
          data={multiChoices}
          value={Array.isArray(value) ? value : []}
          onChange={e => handleChange(e.value)}
          required={ctField.required}
        />
      );
    }
    default:
      return <span>Unsupported field type: {ctField.type}</span>;
  }
};
